import * as React from "react";
import Tooltip from "src/components/shared/Tooltip";
import styled from "styled-components";
import { RestartTimer } from "../Timer.components";

const Title = styled(Tooltip.Title)<{ canRestart: boolean }>`
  font-size: ${({ theme }) => theme.fonts.sizes.xs};
  margin-bottom: ${({ canRestart }) => !canRestart && 0};

  @media ${({ theme }) => theme.mq.md} {
    font-size: ${({ theme }) => theme.fonts.sizes.s};
  }
`;

interface Props {
  onClose: () => void | Promise<void>;
  onRestart?: () => void | Promise<void>;
}

export const TimerEndedTooltip: React.FunctionComponent<Props> = ({
  onClose,
  onRestart,
}) => {
  return (
    <>
      <Title canRestart={!!onRestart}>Times up!</Title>
      <Tooltip.CloseIcon onClick={onClose} />
      {onRestart && (
        <Tooltip.Message>
          <RestartTimer onClick={onRestart}>Restart</RestartTimer>
        </Tooltip.Message>
      )}
    </>
  );
};
